import { useMemo, useState } from "react";

export default function useControl(initialState = false) {
  const [state, setState] = useState(initialState);

  return useMemo(
    () => ({
      state,
      isOpen: state,
      isOn: state,
      open: () => setState(true),
      close: () => setState(false),
      on: () => setState(true),
      off: () => setState(false),
      onChange: (change: boolean) => setState(change)
    }),
    [state]
  );
}
